import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from "@mui/material";

const SignOutDialog = ({ open, onConfirm }) => {
  return (
    <Dialog
      open={open}
    >
      <DialogTitle>Session expired</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Your session has expired. Please sign out and log in again?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button style={{textTransform:"capitalize"}} variant="text" onClick={onConfirm}>
          Sign Out
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SignOutDialog;
